import { render, staticRenderFns } from "./TabStaffEntry.vue?vue&type=template&id=0b6babcd"
import script from "./TabStaffEntry.vue?vue&type=script&lang=js"
export * from "./TabStaffEntry.vue?vue&type=script&lang=js"
import style0 from "./TabStaffEntry.vue?vue&type=style&index=0&id=0b6babcd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports